
<template>
  <!-- Top -->
  <div id="footertop"
    class="footer-top"
    ref="footertop">
    <div class="footer-top-bg img-lazyload-container">
      <img class="img-lazyload" data-lazyload="true" src="/images/footer-bg-top.jpg"
        alt="Montagne enneigée">
    </div>
    <div class="footer-top-mountain img-lazyload-container">
      <img class="img-lazyload" data-lazyload="true" src="/images/footer-montagne-min.png"
        alt="Montagne enneigée">
    </div>
    <div class="footer-top-nuages">
      <div class="footer-top-nuages-item footer-top-nuages-4 img-lazyload-container">
        <img class="img-lazyload" data-lazyload="true" src="/images/footer-nuage-4-min.png"
          alt="Nuage">
      </div>
      <div class="footer-top-nuages-item footer-top-nuages-3 img-lazyload-container">
        <img class="img-lazyload" data-lazyload="true" src="/images/footer-nuage-3-min.png"
          alt="Nuage">
      </div>
      <div class="footer-top-nuages-item footer-top-nuages-2 img-lazyload-container">
        <img class="img-lazyload" data-lazyload="true" src="/images/footer-nuage-2-min.png"
          alt="Nuage">
      </div>
      <div class="footer-top-nuages-item footer-top-nuages-1 img-lazyload-container">
        <img class="img-lazyload" data-lazyload="true" src="/images/footer-nuage-1-min.png"
          alt="Nuage">
      </div>
    </div>
    <div class="footer-top-content">
      <div class="footer-top-title">
        <img src="/images/foot-logo-2.png" alt="">
      </div>
      <p class="footer-top-sub ft-20">{{$t('footerTop.text')}}</p>
    </div>
  </div>
</template>

<script>
// import { TimelineMax, Power3 } from 'gsap/TweenMax'
import { qs } from '@/util/dom.js'
import scroll from '@/oceanSchool/scroll.js'

export default {
  beforeDestroy () {
    scroll.unbind('move-footertop')
    this.topNuages = null
    this.topMountain = null
  },

  mounted () {
    this.$nextTick(() => {
      this.topNuages = qs('.footer-top-nuages', this.$el)
      this.topMountain = qs('.footer-top-mountain', this.$el)

      scroll.bind('move-footertop', this.scrollMove)
    })
  },

  methods: {
    scrollMove () {
      if (!this.$refs.footertop) return

      const { top } = this.$refs.footertop.getBoundingClientRect()
      if (top > 0 && top < window.innerHeight) {
        const e = parseInt((1 - top / window.innerHeight) * 100)
        this.setTranslateY(this.topNuages, -e * 3)
        this.setTranslateY(this.topMountain, -e * 1)
      }
    },

    setTranslateY (t, e) {
      e = e === null ? 0 : e
      t.style.transform = `translateY(${e}px)`
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-top {
  text-align: center;
  margin-top: 200px;
  margin-bottom: 480px;
  position: relative
}

.footer-top-title {
  // font-size: 200px;
  // line-height: 200px;
  color: #242a3a;
}

.footer-top-sub {
  color: #242a3a;
  // font-family: geomanistbook,Sans-Serif;
  text-transform: uppercase;
  letter-spacing: 0.4em;
}

.footer-top-bg {
  position: absolute;
  width: 100%;
  left: 0
}

.footer-top-bg img {
  width: 100%
}

.footer-top-title {
  position: relative;
  // z-index: 1030;
  z-index: 1050;
  top: 100px;
  will-change: transform;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-top-sub {
  position: relative;
  z-index: 1050;
  top: 100px;
}

.footer-top-mountain {
  position: absolute;
  right: 23.3%;
  top: 66.3%;
  height: 0;
  padding-bottom: 35.8%;
  width: 46.8%;
  z-index: 1050;
}

.footer-top-mountain img {
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0
}

.footer-top-nuages {
  position: absolute;
  z-index: 1080;
  top: 0;
  padding-bottom: calc(686 / 1440 * 100%);
  width: 100%;
  pointer-events: none
}

.footer-top-nuages img {
  position: absolute;
  width: 100%;
  height: 100%
}

.footer-top-nuages-item {
  width: 100%;
  position: absolute;
  left: 0;
  height: 100%;
  will-change: transform;
  top: 280px
}

.footer-top-nuages-item img {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0
}

.footer-top-nuages-1:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -2000px;
  background-color: #fff;
  width: 100%;
  height: 2000px
}

// .footer-top-title, .footer-top-sub {
//   transform: translateY(-100px);
// }
@media(max-width: 768px){
  .footer-top{
    display: none;
  }
}
</style>
